module.exports = __webpack_public_path__ + "static/media/event_csv_appload_black.4c5fc260.svg";